import {type RadicalStorageBooking} from '@chekin/core';
import {BookingCard} from 'components/upselling/BookingCard';

type Props = {
  bookings: RadicalStorageBooking[];
  defaultExpanded?: boolean;
};

function LuggageBookingsList({bookings, defaultExpanded}: Props) {
  return (
    <div className="flex flex-col gap-3">
      {bookings.map(booking => (
        <BookingCard
          key={booking.id}
          booking={booking}
          defaultExpanded={defaultExpanded}
        />
      ))}
    </div>
  );
}

export {LuggageBookingsList};
